import { Injectable } from '@angular/core'

declare var $:any;

@Injectable()
export class CSVService{

    parse(csv:string):Array<string>{
        return $.simple_csv(csv);
    }
}